import { InputText, InputTextProps } from "primereact/inputtext";
import { ChangeEvent } from "react";

import BaseControllerField, { BaseControllerFieldProps } from "../BaseContollerField";

export type InputTextFieldProps = InputTextProps &
  React.InputHTMLAttributes<HTMLInputElement> &
  BaseControllerFieldProps & {
    /**
     * A pure function to transform the input data before setting it in the form state
     */
    transformOut?: (value: string) => string;
  };

const dummyTransformerOut = (value: string) => value;

/**
 * ### Integra el <a href="https://primereact.org/inputtext" target="_blank">InputText de primeReact</a> con <a href="https://legacy.react-hook-form.com/advanced-usage/#ConnectForm" target="_blank">react-hook-form</a>
 *
 * Incorpora props como label, name y required + todas las props del InputText
 *
 * ```tsx
 * import { FormProvider, useForm } from "react-hook-form";
 * import { InputTextField } from "@/@/components/organisms/Form";
 *
 *
 * const form = useForm();
 * 
 *  ...
 *
 * <FormProvider {...form}>
    <InputTextField label="Nombre" name="firstName"  />
    <InputTextField label="Apellido" name="lastName" required />
 * </FormProvider>
 *  ```
 *
 */
export const InputTextField = ({
  name,
  label,
  required,
  helpText,
  id,
  transformOut = dummyTransformerOut,
  ...props
}: InputTextFieldProps) => {
  const baseProps = {
    id,
    label,
    name,
    required,
    helpText,
    invalid: props.invalid,
  };

  return (
    <BaseControllerField
      {...baseProps}
      render={({ field, fieldState, idHelp, id }) => {
        if (props.disabled) {
          props.placeholder = "";
        }

        const handleOnChange = (e: ChangeEvent<HTMLInputElement>) => {
          field.onChange(transformOut(e.target.value));
        };

        return (
          <InputText
            aria-describedby={idHelp}
            aria-label={props["aria-label"] ?? label}
            type="text"
            variant="outlined"
            {...field}
            invalid={fieldState.invalid}
            onChange={handleOnChange}
            {...props}
            id={id}
          />
        );
      }}
    />
  );
};

export default InputTextField;
